import { ICellRendererParams } from "ag-grid-community";

/**
 * Generic cell renderer to display "label" and "description" in a column.
 * Label is bold, description is smaller and gray.
 * 
 * T is the row data type that must have `label` and `description` fields.
 */
export const NameDescriptionCellRenderer = <
  T extends { label: string; description: string }
>(
  props: ICellRendererParams<T>
) => {
  const { data } = props;
  if (!data) return null;

  return (
    <div style={{ lineHeight: 1.25 }}>
      <div style={{ fontWeight: 600, marginBottom: 2 }}>
        {data.label}
      </div>
      <div style={{ fontSize: "0.85em", color: "#555" }}>
        {data.description}
      </div>
    </div>
  );
};